import React from 'react'
import { GooglePlayButton } from './google-play-button'
import { IosAppStoreButton } from './ios-app-store-button'

// animate__animated animate__fadeInUp
export default function AppStoreButtons({ iosLink, googleLink, className = '' }) {
  return (
    <div className={`${className} justify-content-center `}>
      <IosAppStoreButton url={iosLink} />
      <GooglePlayButton url={googleLink} />
    </div>
  )
}
